export default __webpack_public_path__ + "static/media/org-intro.76f3a2d3.jpg";